import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';

import Options from '../shared/Options';
// import DebugData from '../shared/DebugData';
import OptionWithIcon from '../GoalsFlow/OptionIcon';
import Button from '../shared/Button';
import { ThemeShape, Default } from '../theme/Options';
import Title from '../shared/Title';
import Text from '../shared/Text';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';

import { HEADER_HEIGHT } from '../GoalsFlow/styles';
import { breakpoints, palette } from '../../constants/styles';
import StepCounter from '../shared/StepCounter';
import FlowHeader from '../shared/FlowHeader';

const StyledCreditPicker = styled.div`
  padding: 0 20px;
  margin-top: ${HEADER_HEIGHT}px;
  width: 100%;
  background-color: white;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

const SubmitButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledCreditPickerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 2px 2px 15px -3px rgba(0, 0, 0, 0.25);
  margin-bottom: 40px;
  margin-top: 0.3rem;
`;

const StyledPickerTitle = css`
  margin-top: 20px;
  margin-bottom: -10px;
`;

const StyledSpanEnter = styled.span`
  display: none;
  ${breakpoints.tabletLandscape} {
    font-size: 0.8em;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    max-height: 15px;
    margin-right: 0.5em;
    background-color: ${palette.secondaryColorShy};
    padding: 5px;
    border-radius: 8px;
    border-color: ${palette.sweetGray};
    border: 1px solid;
    color: ${palette.sweetGray};
  }
`;

class CreditPicker extends Component {
  state = { importantKeyIsDown: false };

  componentWillMount() {
    const { pickerOptions } = this.props;

    this.setState({
      goals: pickerOptions,
      defaultValues: { goals: [] },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      const { pickerOptions } = nextProps;

      this.setState({
        goals: pickerOptions,
        defaultValues: { goals: [] },
      });
    }
  }

  componentDidMount = () => {
    this.props.mixpanel();
    document.addEventListener('keyup', this.keyUp, false);
    document.addEventListener('keydown', this.keyDown, false);
  };

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyUp, false);
    document.removeEventListener('keydown', this.keyDown, false);
  }

  keyUp = (ev) => {
    if (ev.keyCode === 13 || ev.keyCode === 9) {
      ev.preventDefault();
      document.getElementById('submit_picker').click();
    }
  };

  keyDown = (ev) => {
    switch (ev.keyCode) {
      case 65:
      case 97:
      case 66:
      case 98:
      case 67:
      case 99:
      case 68:
      case 100:
      case 69:
      case 101:
      case 70:
      case 102:
      case 71:
      case 103:
      case 72:
      case 104:
      case 73:
      case 105:
      case 74:
      case 106:
        ev.preventDefault();
        if (!this.state.importantKeyIsDown) {
          this.setState({ importantKeyIsDown: true });
        }
        break;
      default:
        break;
    }
  };

  isGoalListEmpty = (props) => {
    const goals = props.values.goals || [];
    return goals.length === 0;
  };

  handleGoBack = () => {
    const { goBack } = this.props;
    goBack(() => {});
  };

  render() {
    const { numberOfSteps, macroStep, goForward, title, previousTitle } = this.props;
    return (
      <StyledCreditPickerContainer>
        <ScrollToTopOnMount />
        <FlowHeader
          goBack={() => {
            this.handleGoBack();
          }}
          goForward={goForward}
          title={title}
          previousTitle={previousTitle}
          macroStep={macroStep}
          numberOfSteps={numberOfSteps}
        />
        <StyledCreditPicker>
          <Title level={3} styles={StyledPickerTitle}>
            {this.props.pickerTitle}
          </Title>
          <Formik
            onSubmit={(values, { setSubmitting }) => {
              if (!values.goals) {
                this.props.onStepSubmit(this.state.defaultValues);
              } else {
                this.props.onStepSubmit(values);
              }
              setSubmitting(false);
            }}
          >
            {(props) => (
              <StyledForm>
                <Options
                  isFocused
                  importantKeyIsDown={this.state.importantKeyIsDown}
                  callback={this.importantKeyCallback}
                  name="goals"
                  values={this.state.goals}
                  renderItem={(
                    { hotkey, icon, label, dimensions }, // Chulada! 👌
                  ) => (
                    <Fragment>
                      <OptionWithIcon icon={icon} dimensions={dimensions} hotkey={hotkey}>
                        {label}
                      </OptionWithIcon>
                    </Fragment>
                  )}
                  multiple
                />
                <SubmitButtonContainer>
                  {this.isGoalListEmpty(props) ? (
                    <Button
                      id="submit_picker"
                      type="submit"
                      disabled={false}
                      color="default"
                      styles={StyledButton}
                    >
                      <StyledSpanEnter>ENTER</StyledSpanEnter>
                      <Text type="buttonText" color="white" medium>
                        {this.props.pickerOptOut}
                      </Text>
                    </Button>
                  ) : (
                    <Button
                      id="submit_picker"
                      type="submit"
                      disabled={this.isGoalListEmpty(props)}
                      color={!this.isGoalListEmpty(props) ? 'default' : 'disabled'}
                      styles={StyledButton}
                    >
                      <StyledSpanEnter>ENTER</StyledSpanEnter>
                      <Text type="buttonText" color="white" medium>
                        Listo
                      </Text>
                    </Button>
                  )}
                </SubmitButtonContainer>
                {/* <DebugData data={props} /> */}
              </StyledForm>
            )}
          </Formik>
        </StyledCreditPicker>
      </StyledCreditPickerContainer>
    );
  }
}

CreditPicker.propTypes = {
  onStepSubmit: PropTypes.func,
  theme: ThemeShape,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  title: PropTypes.string,
  pickerTitle: PropTypes.string,
  pickerOptOut: PropTypes.string,
  pickerOptions: PropTypes.object,
  macroStep: PropTypes.number,
  numberOfSteps: PropTypes.number,
};

CreditPicker.defaultProps = {
  onStepSubmit: () => {},
  theme: Default,
  goBack: () => {},
  goForward: () => {},
  title: 'Template Title',
  pickerTitle: 'Template Title',
  pickerOptOut: 'Template Opt Out',
  pickerOptions: {},
  macroStep: 0,
  numberOfSteps: 5,
};

export default CreditPicker;
